var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-main',[_c('div',{staticClass:"d-flex justify-center align-center fill-height background-gradient-image"},[_c('transition',{attrs:{"name":"route-fade","mode":"out-in"}},[_c('router-view')],1)],1)]),_c('os-global-dialogs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }